<template>

<HowItWorks></HowItWorks>
  <!-- <Footer></Footer> -->
</template>

<script>

import HowItWorks from '@/components/HowItWorks.vue'

export default {
  name: 'Home',
  components: {
    HowItWorks
  }
}
</script>


